
























import { Component, Vue } from "vue-property-decorator";
import store from "../store/index";
import { imageApiUrl } from "../settings";

@Component({ store: store })
export default class ImageList extends Vue {
  readonly apiUrl = imageApiUrl;

  get imageList() {
    return this.$store.state.imageList;
  }

  deleteImage(image: any) {
    this.$store.dispatch("deleteImage", image);
  }

  mounted() {
    this.$store.dispatch("refreshImageList");
  }
}
